import purchaseCouponHistory from '../../service/apis/purchaseCouponHistory'

import { formatRequestData } from '../../plugins/helper'

import { Message } from 'element-ui'

const state = {
  purchaseCouponInfos: {
    'pageNum': 1,
    'pageSize': 20,
    'dataList': [
    ],
    'total': 0
  },
  purchaseCouponInfosLoading: true,
  orderInfo: {
  },
  getOrderInfoLoading: true,
  comboBoxCouponType: [],
  comboBoxAuditingType: [],
  getOrderRefundInfo: false,
  refundOrderSuccess: false,
  downLoading: false,
  creatDownloadTaskSuccess: false,
  creatDownloadTaskFail: false
}

// 用于手动初始化数据
const initState = JSON.parse(JSON.stringify(state))

const getters = {}

const actions = {
  async getPurchaseCouponInfos ({ commit, state }, data) {
    try {
      commit('setLoadingTrue', 'purchaseCouponInfosLoading')
      let requestData = formatRequestData(data)
      let res = await purchaseCouponHistory.getHistory(requestData)
      commit('setPurchaseCouponInfos', res.data)
    } catch (e) {
      console.log(e)
    } finally {
      // 最终会关闭 loading
      commit('setLoadingFalse', 'purchaseCouponInfosLoading')
    }
  },
  downloadHistory ({ commit }, params) {
    commit('setLoadingTrue', 'downLoading')
    purchaseCouponHistory.downloadHistory(formatRequestData(params)).then(res => {
      commit('setLoadingFalse', 'downLoading')
      if (res.status === 0) {
        commit('setLoadingTrue', 'creatDownloadTaskSuccess')
      }
      // console.log(res)
    }).catch(() => {
      commit('setLoadingFalse', 'downLoading')
      commit('setLoadingTrue', 'creatDownloadTaskFail')
    })
  },
  getComboBoxCouponType ({ commit, state }, data) {
    let requestData = formatRequestData(data)
    purchaseCouponHistory.getComboBoxCouponType(requestData).then(res => {
      commit('setComboBoxCouponType', res.data)
    })
  },
  getComboBoxAuditingType ({ commit, state }, data) {
    let requestData = formatRequestData(data)
    purchaseCouponHistory.getComboBoxCouponType(requestData).then(res => {
      commit('setComboBoxAuditingType', res.data)
    })
  },
  async getOrderInfo ({ commit, state }, data) {
    try {
      commit('setLoadingTrue', 'getOrderInfoLoading')
      let requestData = formatRequestData(data)
      let res = await purchaseCouponHistory.getOrderInfo(requestData)
      commit('setOrderInfo', res.data)
    } catch (e) {
      console.log(e)
    } finally {
      commit('setLoadingFalse', 'getOrderInfoLoading')
    }
  },
  async cancelOrder ({ dispatch, commit, state }, data) {
    try {
      let requestData = formatRequestData(data.cancel)
      let res = await purchaseCouponHistory.cancelOrder(requestData)
      if (res.status === 0) {
        Message.success({
          message: '取消成功',
          onClose: function () {
            dispatch('getPurchaseCouponInfos', data.formData)
          },
          duration: 500
        })
      }
    } catch (e) {
      console.log(e)
    } finally {

    }
  },
  // 清空前一次的 vuex state
  initState ({ commit }, data) {
    commit('toInitState', data)
  },
  getOrderRefundInfo ({ commit }, params) {
    purchaseCouponHistory.getOrderRefundInfo(params).then(res => {
      commit('getOrderRefundInfo', {res})
    })
  },
  refundOrder ({ commit }, params) {
    purchaseCouponHistory.refundOrder(params).then(res => {
      commit('refundOrder', {res})
    })
  }
}

const mutations = {
  setPurchaseCouponInfos (state, couponInfos) {
    state.purchaseCouponInfos = couponInfos
  },
  setComboBoxCouponType (state, data) {
    state.comboBoxCouponType = data
  },
  setComboBoxAuditingType (state, data) {
    state.comboBoxAuditingType = data
  },
  setOrderInfo (state, data) {
    state.orderInfo = data
  },
  setLoadingTrue (state, stateKey) {
    state[stateKey] = true
  },
  setLoadingFalse (state, stateKey) {
    state[stateKey] = false
  },
  toInitState (state, stateKey) {
    state[stateKey] = initState[stateKey]
  },
  getOrderRefundInfo (state, payload) {
    state.getOrderRefundInfo = payload.res
  },
  refundOrder (state, payload) {
    state.refundOrderSuccess = payload.res
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
